import { createSlice } from "@reduxjs/toolkit";
import {
  getInvoices,
  getInvoiceByNumber,
  addNewInvoice,
  updateInvoice,
  deleteInvoice,
} from "./thunk";

export const initialState = {
  invoices: [],
  error: {},
  isLoading: false,
  isInvoicesSuccess: false,
  isInvoicesFailed: false,

  invoiceSpecial: [],
  isSpecialLoading: false,
  isInvoiceSpecialSuccess: false,
  isInvoiceSpecialFail: false,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getInvoices/ ]=======================================
    builder.addCase(getInvoices.pending, (state) => {
      state.isLoading = true;
      state.isInvoicesSuccess = false;
      state.error = null;
    });
    builder.addCase(getInvoices.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isInvoicesSuccess = true;
      state.invoices = action.payload;
    });
    builder.addCase(getInvoices.rejected, (state, action) => {
      state.isLoading = false;
      state.isInvoicesSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewInvoice.fulfilled, (state, action) => {
      state.invoices.push(action.payload);
      state.isInvoiceAdd = true;
      state.isInvoiceAddFail = false;
    });

    builder.addCase(addNewInvoice.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isInvoiceAdd = false;
      state.isInvoiceAddFail = true;
    });

    builder.addCase(updateInvoice.fulfilled, (state, action) => {
      state.invoices = state.invoices.map((invoice) =>
        invoice._id.toString() === action.payload._id.toString()
          ? { ...invoice, ...action.payload }
          : invoice
      );
      state.isInvoiceUpdate = true;
      state.isInvoiceUpdateFail = false;
    });

    builder.addCase(updateInvoice.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isInvoiceUpdate = false;
      state.isInvoiceUpdateFail = true;
    });

    builder.addCase(deleteInvoice.fulfilled, (state, action) => {
      state.invoices = (state.invoices || []).filter(
        (invoice) => invoice._id.toString() !== action.payload.id.toString()
      );

      state.isInvoiceDelete = true;
      state.isInvoiceDeleteFail = false;
    });

    builder.addCase(deleteInvoice.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isInvoiceDelete = false;
      state.isInvoiceDeleteFail = true;
    });

    // builder.addCase(getInvoiceByNumber.fulfilled, (state, action) => {
    //   state.invoiceSpecial = action.payload;
    //   state.isInvoiceSpecialFail = false;
    //   state.isInvoiceSpecialSuccess = true;
    // });

    // builder.addCase(getInvoiceByNumber.rejected, (state, action) => {
    //   state.error = action.payload?.error ?? action.error?.message ?? null;
    //   state.isInvoiceSpecialFail = true;
    //   state.isInvoiceSpecialSuccess = false;
    // });

    builder.addCase(getInvoiceByNumber.pending, (state) => {
      state.isSpecialLoading = true;
      state.isInvoiceSpecialSuccess = false;
      state.error = null;
    });
    builder.addCase(getInvoiceByNumber.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isInvoiceSpecialSuccess = true;
      state.invoiceSpecial = action.payload;
    });
    builder.addCase(getInvoiceByNumber.rejected, (state, action) => {
      state.isLoading = false;
      state.isInvoiceSpecialSuccess = false;
      state.error = action.error.message;
    });
  },
});

export default invoiceSlice.reducer;
